import { createContext, ReactNode, useContext, useMemo } from 'react'

import { AccountVestingTypeEnum } from 'constants/vesting'

interface AccountVestingContextTypeV2 {
  type?: AccountVestingTypeEnum
}

const AccountVestingContextV2 = createContext<AccountVestingContextTypeV2>({})

interface AccountVestingContextPropsV2 {
  type: AccountVestingTypeEnum
  children: ReactNode
}

const AccountVestingProviderV2: React.FC<AccountVestingContextPropsV2> = ({ type, children }) => {
  const value = useMemo(() => ({ type }), [type])

  return (
    <AccountVestingContextV2.Provider value={value}>{children}</AccountVestingContextV2.Provider>
  )
}

const useAccountVestingContextV2 = (): AccountVestingContextTypeV2 => {
  const context = useContext(AccountVestingContextV2)
  if (context === undefined) {
    throw new Error('useAccountVestingContextV2 must be used within AccountVestingProviderV2')
  }
  return context
}

export { AccountVestingProviderV2, useAccountVestingContextV2 }
